import React from 'react';
import styled from 'styled-components';

export const StyledFlippedIcon = styled.div`
  transform: scaleX(-1);
  -moz-transform: scaleX(-1);
  -webkit-transform: scaleX(-1);
  -ms-transform: scaleX(-1);
`;
